'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import a$1 from "../defs/Users.es.js";
const o = a.forwardRef((r, s) => /* @__PURE__ */ a.createElement(p, { ref: s, ...r, weights: a$1 }));
o.displayName = "UsersIcon";
const n = o;
export {
  n as Users,
  o as UsersIcon
};
